import { SvgIcon } from '@material-ui/core'

export default (props) => (
  <SvgIcon {...props}>
    <path d='M3 3h18v18H3z' />
  </SvgIcon>
)
